import axios from "axios";
import { BACKEND_URL, HEADERS, STORAGE_KEYS, APP_VERSION, API_PATH } from "../const";
import AuthService from "./AuthService";

async function getData(path, headers = {}, params = {}, responseType) {
  const resp = await _request(path, {
    method: "GET",
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}

async function postData(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: "POST",
    data,
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}

async function get(path, headers, params, responseType) {
  const resp = await _request(path, {
    method: "GET",
    ..._genParams(headers, params, responseType),
  });

  return _getResponse(resp);
}

async function post(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: "POST",
    data,
    ..._genParams(headers, params, responseType),
  });

  return _getResponse(resp);
}

async function destroy(path, data, headers, params, responseType) {
  const resp = await _request(path, {
    method: "DELETE",
    data,
    ..._genParams(headers, params, responseType),
  });
  return _getResponseData(resp);
}

async function put(path, data) {
  const resp = await _request(path, {
    method: "PUT",
    data,
    ..._genParams(),
  });
  return _getResponseData(resp);
}

async function patch(path, data, headers, params, responseType) {
  const resp = await _request(path, { method: "PATCH", data, ..._genParams(headers, params, responseType) });
  return _getResponseData(resp);
}

async function _request(path, config) {
  try {
    return await axios({ url: `${BACKEND_URL}${path}`, ...config });
  } catch (error) {
    _isInvalidTokenError(error) && path !== API_PATH.LOGOUT && (await _handleInvalidTokenError());
    throw error;
  }
}

function _genParams(headers = {}, params = {}, responseType = undefined) {
  const localHeaders = {
    "Content-Type": "application/json",
    "User-Interface": "web",
    "App-Version": APP_VERSION,
    flavour: "sanoft",
    ...headers,
  };

  if (!headers[HEADERS.SHOP_ID]) {
    const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
    if (shopId) {
      localHeaders[HEADERS.SHOP_ID] = shopId;
    }
  }

  const terminalAuthToken = localStorage.getItem(STORAGE_KEYS.TERMINAL_AUTH_TOKEN);
  if (terminalAuthToken) {
    localHeaders[HEADERS.AUTH] = `Terminal ${terminalAuthToken}`;
  } else {
    const userAuthToken = localStorage.getItem(STORAGE_KEYS.USER_AUTH_TOKEN);
    if (userAuthToken) {
      localHeaders[HEADERS.AUTH] = `Token ${userAuthToken}`;
    }
  }

  return {
    headers: localHeaders,
    params,
    responseType,
  };
}

async function _getResponseData(resp) {
  if (resp?.data?.status === 200) {
    return resp.data.data;
  }
  throw new Error((resp.data || {}).message);
}

async function _getResponse(resp) {
  if (resp?.data?.status === 200) {
    return resp.data;
  }
  throw new Error((resp.data || {}).message);
}

function _isInvalidTokenError(error) {
  return error?.response?.status === 401 || error?.response?.status === 403;
}

async function _handleInvalidTokenError() {
  await AuthService.logout();
  window.location.reload();
}

const BackendService = {
  getData,
  postData,
  get,
  post,
  put,
  patch,
  destroy,
};

export default BackendService;
